import React from 'react';
import Header from '../../components/Header';
import Camaras from '../../components/Camaras';
import DatosGenerales from '../../components/DatosGenerales';
import PrintStyles from '../../components/estilos';
import Footer from '../../../components/Footer/Footer';

export default function General(props) {
  return (
    <>
      <PrintStyles/>
      <div className="pdfPrint">
        <Header data={props.data} nomenclator={props.nomenclator} ini={props.ini}/>
        <div className="main">
          <DatosGenerales data={props.data} nomenclator={props.nomenclator} ini={props.ini} className="datosGeneralesTotal" />

          <section className="camaracircunscripcion">
            <Camaras className="camaracircunscripcion" />
          </section>
        </div>
        <Footer/>
      </div>
    </>
  );
}
